import type { SupabaseClient } from '@supabase/supabase-js'

export interface KuendigungsVorschau {
  tenant_id: string
  kanal: 'stripe' | 'apple' | 'google'
  status: string
  contract_term: 'monthly' | 'yearly'
  wirksam_am: string | null
  bereits_gekuendigt: boolean
  konto_loeschung_laeuft: boolean
  beendet: boolean
  widerruf_moeglich: boolean
  abschluss_freigegeben: boolean
}
export interface KuendigungsErgebnis {
  geschrieben: boolean
  ergebnis: string
  wirksam_am?: string | null
}
async function rpc<T>(sb: SupabaseClient | null, name: string, args: Record<string, unknown>): Promise<T> {
  if (!sb) throw new Error('no_backend')
  const { data, error } = await sb.rpc(name, args)
  if (error?.message === 'crm_datum_nicht_freigegeben') throw new Error('crm_datum_nicht_freigegeben')
  if (error || !data) throw new Error('kuendigung_nicht_verfuegbar')
  return data as T
}
export function kuendigungsVorschau(sb: SupabaseClient | null, tenantId: string): Promise<KuendigungsVorschau> {
  return rpc(sb, 'abo_kuendigung_vorschau', { p_tenant: tenantId })
}
export function aboKuendigen(sb: SupabaseClient | null, tenantId: string, grund = ''): Promise<KuendigungsErgebnis> {
  return rpc(sb, 'abo_kuendigen', { p_tenant: tenantId, p_grund: grund.trim() || null })
}
export function kuendigungZuruecknehmen(sb: SupabaseClient | null, tenantId: string): Promise<KuendigungsErgebnis> {
  return rpc(sb, 'abo_kuendigung_zuruecknehmen', { p_tenant: tenantId })
}
/** Vertragsdatum in Wien, auch kurz nach Mitternacht; kein Abschneiden am UTC-Tag. */
export function kuendigungsDatum(iso: string, lang: 'de' | 'en'): string {
  return new Intl.DateTimeFormat(lang === 'de' ? 'de-AT' : 'en-GB', {
    day: 'numeric', month: 'long', year: 'numeric', timeZone: 'Europe/Vienna',
  }).format(new Date(iso))
}
